import * as React from 'react';
import { useFilters } from '@/hooks';
import { ComboboxSearch } from '@/components/ui/comboboxSearch';
import { Icon } from '@/components/common';
import Icons from '@/const/icons';

export const ClientFilterV2 = () => {
	const FILTER_KEY = 'search';
	const { setParamFilter, hasFilter, query } = useFilters();
	const [open, setOpen] = React.useState(false);

	const handleSelectFilters = (value?: string) => {
		setParamFilter(FILTER_KEY, value);
	};

	const handleClearAll = () => {
		setParamFilter(FILTER_KEY, '');
	};

	return (
		<ComboboxSearch
			placeholder=""
			open={open}
			setOpen={setOpen}
			value={(query[FILTER_KEY] as string) || ''}
			handleSearch={handleSelectFilters}
			handleClearAll={handleClearAll}
			classNameTrigger="h-[33px] !w-fit"
			hasValue={hasFilter(FILTER_KEY)}
			customButton={
				<button className="flex items-center size-8 justify-center rounded-lg p-1 border border-smoke-50">
					<Icon src={Icons.search} className="!w-4 !h-4 text-opacity-black" />
				</button>
			}
		/>
	);
};
